export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "worker.805590d1.worker.js");
}
